"use client";

import { PhotoStack } from "../PhotoStack";
import { SectionShell } from "./SectionShell";

/** What the panel rests on when no menu item is selected. */
export function IdleSection() {
  return (
    <SectionShell>
      <PhotoStack className="aspect-[4/3] w-full" />
    </SectionShell>
  );
}
